import React from 'react';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import ButtonWithConfirmation from './ButtonWithConfirmation';

@injectIntl
class DeleteButton extends React.Component {
  render() {
    const { onDelete, intl, pullRight = true } = this.props;
    return (
      <div className="react-delete-btn-container">
        <ButtonWithConfirmation
          confirmationMessage={intl.formatMessage({
            id: 'default_delete_confirmation'
          })}
          onOption2Select={onDelete}
          option1Label={intl.formatMessage({
            id: 'default_delete_cancel_label'
          })}
          option2Label={intl.formatMessage({
            id: 'default_delete_confirm_label'
          })}
          pullRight={pullRight}
        >
          <i className="fa fa-trash-o" />
        </ButtonWithConfirmation>
      </div>
    );
  }
}

DeleteButton.propTypes = {
  onDelete: PropTypes.func
};

export default DeleteButton;
